"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformOpFields = exports.shallowEqual = exports.testPath = exports.getResourceState = void 0;
const model_1 = require("../model");
// import 'reflect-metadata';
const store_1 = require("../exports/store");
const resource_1 = require("../modules/database/store/selectors/resource");
const dashboard_1 = require("../modules/database/store/selectors/resource/dashboard");
const form_1 = require("../modules/database/store/selectors/resource/form");
const widget_1 = require("../modules/database/store/selectors/resource/widget");
const resource_types_1 = require("../types/resource_types");
const types_1 = require("../types");
/**
 * Register event prototype decorator
 *
 * @EventMeta("RecordUpdated","ATOM")
 * class EventRecordUpdated {
 *  test(){
 *  }
 * }
 */
// export const EventMeta = (name: string, atomType: string = 'ATOM'): ClassDecorator => {
//   return (target: any) => {
//     Reflect.defineMetadata('name', name, target);
//     Reflect.defineMetadata('atomType', atomType, target);
//   };
// };
const getResourceState = (resourceId, resourceType, state) => {
    switch (resourceType) {
        case resource_types_1.ResourceType.Datasheet:
            return (0, resource_1.getDatasheet)(state, resourceId);
        case resource_types_1.ResourceType.Dashboard:
            return (0, dashboard_1.getDashboard)(state, resourceId);
        case resource_types_1.ResourceType.Widget:
            return (0, widget_1.getWidget)(state, resourceId);
        case resource_types_1.ResourceType.Form:
            return (0, form_1.getForm)(state, resourceId);
        default:
            return;
    }
};
exports.getResourceState = getResourceState;
/**
 * pathList = ["recordMap", "recGa2EHHKOTQ", "data", "fldBSXiPB3UQY"]
 * testPathList = ["recordMap", ":recordId", "data",":fieldId"]
 * return {
 *  pass:true,
 *  recordId:recGa2EHHKOTQ,
 *  fieldId:fldBSXiPB3UQY
 * }
 */
const testPath = (pathList, testPathList, flag = true) => {
    const NOT_PASS_RES = {
        pass: false,
    };
    if (!flag || pathList.length !== testPathList.length) {
        return NOT_PASS_RES;
    }
    const res = { pass: true };
    for (let i = 0; i < testPathList.length; i++) {
        if (testPathList[i].startsWith(':')) {
            const pathKey = testPathList[i].slice(1);
            res[pathKey] = pathList[i];
            continue;
        }
        if (pathList[i] !== testPathList[i]) {
            return NOT_PASS_RES;
        }
    }
    return res;
};
exports.testPath = testPath;
const shallowEqual = (objA, objB) => {
    if (objA === objB) {
        return true;
    }
    if (typeof objA !== 'object' || objA === null ||
        typeof objB !== 'object' || objB === null) {
        return false;
    }
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) {
        return false;
    }
    // Test for A's keys different from B.
    for (const key of keysA) {
        if (!Object.hasOwnProperty.call(objB, key) ||
            !Object.is(objA[key], objB[key])) {
            return false;
        }
    }
    return true;
};
exports.shallowEqual = shallowEqual;
const transformOpFields = (props) => {
    const { state, datasheetId, recordData, recordId } = props;
    const snapshot = store_1.Selectors.getSnapshot(state, datasheetId);
    const eventFields = {};
    const newFields = Object.assign({}, recordData);
    Object.keys(snapshot === null || snapshot === void 0 ? void 0 : snapshot.meta.fieldMap).forEach(fieldId => {
        const field = snapshot.meta.fieldMap[fieldId];
        let cellValue = recordData[fieldId];
        // FIXME: Only fill in what is not, there is a problem here. 
        // The change to of op is the latest, and the one obtained from the database search may be old. subject to op
        // There is no field value in recordData, indicating that it is a calculated field. 
        // Whether it is updated or created, it needs to be updated and recalculated.
        if (!recordData.hasOwnProperty(fieldId)) {
            cellValue = store_1.Selectors.getCellValue(state, snapshot, recordId, fieldId);
            newFields[fieldId] = cellValue;
        }
        eventFields[fieldId] = field.type === types_1.FieldType.Formula
            ? model_1.Field.bindContext(field, state).cellValueToString(cellValue)
            : model_1.Field.bindContext(field, state).cellValueToOpenValue(cellValue);
    });
    return {
        fields: newFields,
        eventFields
    };
};
exports.transformOpFields = transformOpFields;
//# sourceMappingURL=helper.js.map